import { render, staticRenderFns } from "./ReportsDashboard.vue?vue&type=template&id=51fec48e&"
import script from "./ReportsDashboard.vue?vue&type=script&lang=js&"
export * from "./ReportsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports